import Box from '@mui/material/Box';
import EnhancedTable, { EnhancedTableProps, EnhancedTableRow } from '#components/EnhancedTable';
import {
  formatCurrency,
} from '#common/utils';

interface CustomerReport {
  rows: EnhancedTableRow[];
  subtotal: number;
  collectionName: string;
}

interface CustomerReportTableProps {
  report: CustomerReport;
  tableProps: Omit<EnhancedTableProps, 'rows'>;
}

export default function CustomerReportTable(props: CustomerReportTableProps) {
  const {
    report,
    tableProps,
  } = props;

  const { rows, subtotal, collectionName } = report;

  // Use the collection name from the backend response
  const displayName = `Collection ${collectionName}`;

  return (
    <>
      <Box sx={{ mt: 2, mb: 1, typography: 'h6' }}>
        {displayName}
      </Box>

      <EnhancedTable
        {...tableProps}
        {...{
          rows,
        }}
      />

      <Box
        sx={{
          typography: 'subtitle2',
          display: 'flex',
          justifyContent: 'flex-end',
          mt: 1,
          mb: 2,
        }}
      >
        <b>Subtotal</b>
        :
        {' '}
        <span data-testid="subtotal">{formatCurrency(subtotal)}</span>
      </Box>
    </>
  );
}
